module.exports = __webpack_public_path__ + "img/Banner-Photos.c2fd0f27.png";